<template>
  <div class="history_header">
    <div class="history_area tabs">
      <div class="tab" :class="{active: mode == 0}" @click="goToGacha">{{ t('ガチャ') }}</div>
      <div class="tab" :class="{active: mode == 1}" @click="change_page('buy-point-history')">{{ t('コイン') }}</div>
      <div class="tab" :class="{active: mode == 2}" @click="change_page('purchase-history')">{{ t('買取') }}</div>
      <!-- <div class="tab" :class="{active: mode == 3}" @click="change_page('market-history')">{{ t('XMarket') }}</div> --> <!-- Xmarket機能廃止 -->
    </div>
    <div class="pending_area tabs" v-if="mode === 0">
      <div class="select-wrapper">
        <select class="select" v-model="shippingOption" @change="changeShippingPage">
          <option value="undecided-detail">{{ t('未選択') }}</option>
          <option value="pending-detail">{{ t('発送待ち') }}</option>
          <option value="shipped-detail">{{ t('発送済み') }}</option>
          <option value="downloaded-detail">{{ t('ダウンロード済み') }}</option>
        </select>
        <span class="arrow"></span>
      </div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  data: () => ({
    mode: 0,
    shippingOption: 'undecided-detail', // 初期値
  }),

  created() {
    const url = window.location.href;
    if (url.includes('/buy-point-history')) {
      this.mode = 1;
    } else if (url.includes('/purchase-history')) {
      this.mode = 2;
    // Xmarket機能廃止
    // } else if (url.includes('/market-history')) {
    //   this.mode = 3;
    } else {
      this.mode = 0;
      if (url.includes('/undecided-detail')) {
        this.shippingOption = 'undecided-detail';
      } else if (url.includes('/shipped-detail')) {
        this.shippingOption = 'shipped-detail';
      } else if (url.includes('/downloaded-detail')) {
        this.shippingOption = 'downloaded-detail';
      } else {
        this.shippingOption = 'pending-detail';
      }
    }
  },

  methods: {
    goToGacha() {
      this.mode = 0;
      this.shippingOption = 'undecided-detail';
      this.$router.push({ path: '/undecided-detail' });
    },
    change_page(page) {
      this.$router.push({ path: `/${page}` });
    },
    changeShippingPage() {
      this.$router.push({ path: `/${this.shippingOption}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.history_header {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  .tabs {
    background-color: #ffffff;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    .tab {
      padding: 5px 20px;
      border-radius: 10px;
      cursor: pointer;
      white-space: pre-wrap;
      color: #555;
      transition: all 0.2s ease-in-out;
    }
    .tab.active {
      background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6);
      color: #fff;
      box-shadow: 0 2px 8px rgba(42, 112, 184, 0.4);
    }
  }
  .history_area {
    width: 80%;
  }
  .pending_area {
    width: 15%;
    justify-content: center;
    .select-wrapper {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      .select {
        text-align: center;
        white-space: pre-wrap;
        width: 100%;
        height: 100%;
        padding: 5px 20px 5px 5px;
        border-radius: 10px;
        background-color: #ffffff;
        border: none;
        cursor: pointer;
        position: relative;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        appearance: none; // ブラウザのデフォルト矢印を消す
        -webkit-appearance: none;
        -moz-appearance: none;
        @media screen and (max-width: $tabletWidth) {
          padding: 10px 20px 10px 5px;
        }
      }
      .arrow {
        position: absolute;
        top: 50%;
        right: 10px;
        width: 6px;
        height: 6px;
        pointer-events: none;
        border: solid black;
        border-width: 2px 2px 0 0;
        transform: translateY(-50%) rotate(135deg);
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .history_header {
    font-size: 12px;
    .tabs {
      padding: 1px;
      .tab {
        padding: 10px 8px;
      }
    }
    .history_area {
      width: 75%;
    }
    .pending_area {
      width: 23%;
      .select-wrapper {
        .select {
          // スマホでの中央寄せ追加対応
          direction: ltr;
          text-indent: 0px;
          option {
            text-align: center;
            direction: ltr;
          }
        }
      }
    }
  }
}
</style>
